import React, { Component } from 'react'
import { Col, Form, Input, Row } from 'antd'

type QuestionTranslationAnswersProps = {
  answers: any[]
}

export default class QuestionTranslationAnswers extends Component<QuestionTranslationAnswersProps> {
  render() {
    const { answers } = this.props

    return (
      <div>
        {
          answers.map(v => (
            <Row key={`translation_answer_${v.uuid}`} gutter={24}>
              <Col xs={12}>
                <Input.TextArea disabled={true} placeholder="Invalid answer" value={v.value} rows={3} cols={50} />
              </Col>

              <Col xs={12}>
                <Form.Item
                  name={['answers', v.uuid, 'value']}
                  rules={[
                    {
                      required: true,
                      message: 'Missing answer text'
                    }
                  ]}
                >
                  <Input.TextArea placeholder="Answer translation" rows={3} cols={50} />
                </Form.Item>
              </Col>
            </Row>
          ))
        }
      </div>
    )
  }
}
